export default "__VITE_ASSET__CC3p39mt__"